var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slide-box" }, [
    _c(
      "div",
      {
        class: _vm.slideBtn,
        on: {
          click: function($event) {
            _vm.showSlide = !_vm.showSlide
          }
        }
      },
      [_c("span", { staticClass: "cd-icons cd-icons-qui-nav" })]
    ),
    _c("div", { class: _vm.slideWrapClass }, [_vm._v("\n        ......\n    ")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4940556a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4940556a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/slide/src/main.vue
// module id = j2Km
// module chunks = 28